export default __webpack_public_path__ + "static/media/Directory.c33f967e.svg";